export default "__VITE_ASSET__GjG4MKuh__"